import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function fetchExams(id: string) {
  const { data } = await unauthenticatedHttp().get(
    `${window.env.API_UNAUTH}/exam-voucher/${id}`
  );

  if (!data) {
    return;
  }
  return data;
}
